import React, { Fragment, Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { startCase } from 'lodash';

class LineField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  sanitizeFullName = (name) => {
    return startCase(name.replace(/[0-9]/g, ''));
  };

  render() {
    const {
      field: { name, value, onChange, onBlur } = this.props,
      form: { touched, errors, setFieldValue } = { touched: { name: null }, errors: { name: null } },
      input,
      label,
      icon,
      type,
      children,
      autoComplete,
      placeholder,
      disabled,
      lastPassIgnore,
      isStartCase,
      editing = false,
    } = this.props;

    return (
      <Fragment>
        <span className="label">
          {icon && <FontAwesomeIcon icon={icon} />}
          {label}
        </span>
        {!editing ? (
          <span className="value">{isStartCase ? startCase(value) : value}</span>
        ) : (
          <span className="input">
            {children || (
              <input
                name={name}
                id={`${name}-input`}
                type={type}
                value={value}
                onChange={onChange}
                onBlur={() => {
                  setFieldValue(name, this.sanitizeFullName(value));
                  onBlur();
                }}
                autoComplete={autoComplete}
                className={`form-control ${errors[name] && touched[name] ? 'is-invalid' : ''}`}
                placeholder={placeholder}
                disabled={disabled}
                data-lpignore={lastPassIgnore}
              />
            )}

            {touched[name] && errors[name] && <div className="invalid-feedback">{errors.name}</div>}
          </span>
        )}
      </Fragment>
    );
  }
}

export default LineField;
